import { allTrackers } from "app/services/track/track";

export const adsTracking = {
    onTableSort: (columnName: string): void => {
        allTrackers.dispatchTrackEvent("Sort", "click", `${columnName}`);
    },
    onFilterClick: (filterName: string): void => {
        allTrackers.dispatchTrackEvent("Drop Down", "open", filterName);
    },
    onFilterApply: (filterName: string): void => {
        allTrackers.dispatchTrackEvent("Filter Table", "click", filterName);
    },
    onRowExpand: (adId: string): void => {
        allTrackers.dispatchTrackEvent("Row Expand", "click", `Ads/${adId}`);
    },
    onExcelDownload: (): void => {
        allTrackers.dispatchTrackEvent("Download", "click", "Ads/Excel");
    },
};
